<template>
  <!-- @click.stop="closeDialog" -->
  <div class="dialog-modal dialogModalNew">
    <general-header roleType="general"></general-header>
    <div class="dialog-header" v-if="title">
      {{ title }}
      <!-- <i class="el-icon-close" @click="closeDialog"></i> -->
      <!-- <span class="icon-bgi"></span> -->
    </div>
    <div class="dialog-outborder">
      <div class="dialog-container" @click.stop>
        <div class="dialog-content" :style="{ width, height }">
          <!-- <i v-if="!title" class="el-icon-close contentClose" @click="closeDialog"></i> -->
          <span class="icon-bgi"></span>
          <slot name="content"></slot>
        </div>
        <div class="dialog-footer" v-if="!noFooter">
          <!-- 返回 -->
          <i class="backbtn" @click="closeDialog">{{ $t('basic.backTo') }}</i>
          <!-- <i class="backbtn">继续添加</i> -->
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import generalHeader from '@/views/headernew'
export default {
  components: {
    generalHeader
  },
  props: {
    visible: {
      default: false
    },
    title: {
      type: String
    },
    width: {
      type: String,
      default: "640px"
    },
    height: {
      type: String,
      default: "auto"
    },
    noFooter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {};
  },
  methods: {
    closeDialog () {
      this.$emit("update:visible", false);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

// .dialog-modal {}
.dialogModalNew {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  color: #ffffff;
  background: rgb(45, 63, 75);

  @keyframes PageFadeIn {
    0% {
      background: rgb(45, 63, 75);
    }

    100% {
      background: rgb(45, 63, 75);
    }
  }

  animation: PageFadeIn 0.5s linear forwards;

  .dialog-header {
    position: relative;
    height: 74px;
    line-height: 74px;
    padding-left: 95px;
    .sc(22px, #ffffff);
    font-weight: bold;

    i {
      position: absolute;
      top: 7px;
      right: 5px;
      .sc(14px, #16D09A);
      cursor: pointer;
    }
  }

  .dialog-outborder {
    // width: 98%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #222D35;
    // padding: 0 20px;
    margin: 0 20px;
  }

  .dialog-container {
    position: relative;
    width: 100%;
    // mask-size: 60px 60px;
    // animation: seed 0.5s;

    display: flex;
    flex-direction: column;
    // height: 82vh;
    height: calc(100vh - 160px);

    .dialog-content {
      width: 100%;
      // padding: 36px 35px;
      // overflow: auto;
      overflow: hidden;
      // max-height: 71vh;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;

      .content_tishi {
        text-align: center;

        .tital {
          display: flex;
          align-items: center;
          justify-content: center;

          .contentdelete {
            font-size: 20px;
            font-weight: 600;
          }

          i {
            font-size: 30px;
            margin-right: 10px;
          }
        }
      }

      .disabledescr {
        // margin-left: 40px;
        display: flex;
        justify-content: center;
        margin-top: 10px;
        font-size: 10px;
      }

      .deletfotter {
        margin-top: 50px;

        .button-hollow {
          width: 100px;
          height: 32px;
          margin: 0 6px;
        }

        .button-solid {
          margin: 0 6px;
          width: 100px;
          height: 32px;
        }
      }

      // 关闭删除弹框
      .contentClose {
        position: absolute;
        top: 7px;
        right: 5px;
        .sc(14px, #16D09A);
        cursor: pointer;
      }
    }

    .dialog-footer {
      background: #222d35;
      height: 60px;
      padding: 0 20px;
      // border-top: 1px solid @borderColor;
      display: flex;
      justify-content: center;
      align-items: center;

      .backbtn {
        font-size: 14px;
        padding: 6px 10px;
        border-radius: 6px;
        cursor: pointer;
        margin: 0 6px;
        color: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      .button {
        font-size: 14px;
        padding: 6px 10px;
        border-radius: 6px;
        // min-width: 100px;
        cursor: pointer;
        margin: 0 6px;
        background-color: @primaryTextColor;
        color: #202D35;
        border: none;
      }

      .button-hollow {
        border-radius: 5px;
        .sc(14px, #666);
        border-color: #ddd;
        .button;

        &:hover {
          background: #f8f9fa;
        }
      }

      .button-solid {
        .button;
      }
    }
  }

  // input
  /deep/.el-input .el-input__inner {
    color: #ffffff;
    background: rgba(43, 56, 66, 1);
    border-color: #A3A9B5;
  }

  /deep/.el-input.is-disabled .el-input__inner {
    // border-color: #A3A9B5;
    border: none;
    background: rgba(43, 56, 66, 1);
    color: rgba(242, 242, 242, 0.5);
  }

  // textarea
  /deep/.el-textarea__inner {
    border-color: #A3A9B5;
    background: rgba(43, 56, 66, 1);
    color: rgba(123, 131, 149, 1);
  }

  // button
  /deep/.button-solid {
    border: none;
    border-radius: 4px;
    background-color: @primaryTextColor;
    color: #202D35;
  }

  /deep/.button-hollow {
    border: none;
    border-radius: 4px;
    // background-color: #16D09A;
    color: #202D35;
  }

  // table
  // /deep/.el-table thead {}
  /deep/.el-table--border,
  .el-table--group {
    border-color: #A3A9B5;
  }

  /deep/.el-table th,
  .el-table tr {
    background: #293942;
    color: #ffffff;
    border-color: #A3A9B5;
  }

  /deep/.el-table__empty-block {
    background: #293942;
  }

  /deep/.el-table__empty-text {
    color: #ffffff;
  }

  // 滚动条
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>
<style lang="less">
.dialogModalNew {
  .dialog-content {
    .el-select {
      width: 100%;
    }

    .el-date-editor.el-input {
      width: 100%;

      .el-input__inner {
        border-radius: 5px;
        padding-left: 15px;
      }
    }

    .el-form-item--small .el-form-item__label {
      font-family: 'Microsoft YaHei';
      color: #ffffff;
      line-height: 20px;
      // padding-bottom: 5px;
    }
  }
}

// 弹窗滑入滑出
.showDialog.dialog-modal {
  @keyframes fadeIn {
    0% {
      // background: transparent;
    }

    100% {
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  animation: fadeIn 0.3s ease-in-out forwards;
}

.showDialog.dialog-modal .dialog-outbox {
  @keyframes popupEnter {
    0% {
      // transform: translateY(-1000px);
      // margin-top: -100vh;
    }

    100% {
      // transform: translateY(0px);
      // margin-top: 25vh;
    }
  }

  // animation: popupEnter 0.3s ease-in-out forwards;
}

// 弹框滑出
.hideDialog.dialog-modal .dialog-outbox {
  @keyframes popupLeave {
    0% {
      // transform: translateY(0px);
      // margin-top: 25vh;
    }

    100% {
      // transform: translateY(-100px);
      // margin-top: -100vh;
    }
  }

  // animation: popupLeave 0.5s ease-in-out forwards;
}

.hideDialog.dialog-modal {
  @keyframes fadeOut {
    0% {
      // background: transparent;
    }

    100% {
      // background: transparent;
      top: -1000px;
      z-index: -1;
    }
  }

  animation: fadeOut 100s ease-in-out forwards;
}
</style>
